import { FormattedMessage, useIntl } from 'react-intl';

import * as S from './styles';
import Img5 from '../../imgs/5.jpeg';
import { Band, Inner, SectionHead } from '../ui/Section';
import { PriceGroup, PriceGrid } from '../ui/PriceList';
import Reveal from '../ui/Reveal';
import { HandIcon, PolishIcon } from '../ui/NailIcons';
import { BANHO_DE_GEL } from '../../consts/prices';

const span = { span: (chunks) => <span>{chunks}</span> };

function BanhoGel() {
  const intl = useIntl();

  return (
    <Band>
      <Inner>
        <SectionHead eyebrow={<FormattedMessage id="prices.eyebrow" />}>
          <FormattedMessage id="gel.title" values={span} />
        </SectionHead>

        <Reveal>
          <S.Intros>
            <S.Intro>
              <HandIcon size={44} className="mark" />
              <p>
                <FormattedMessage id="gel.description1" />
              </p>
            </S.Intro>
            <S.Intro>
              <PolishIcon size={38} className="mark" />
              <p>
                <FormattedMessage id="gel.description2" />
              </p>
            </S.Intro>
          </S.Intros>
        </Reveal>

        <PriceGrid>
          <Reveal>
            <PriceGroup
              title={<FormattedMessage id="gel.application" />}
              items={BANHO_DE_GEL.aplicacao}
            />
          </Reveal>
          <Reveal delay={80}>
            <PriceGroup
              title={<FormattedMessage id="gel.maintenance" />}
              items={BANHO_DE_GEL.manutencao}
            />
          </Reveal>
          <Reveal delay={160}>
            <PriceGroup
              title={<FormattedMessage id="gel.additionals" />}
              items={BANHO_DE_GEL.adicionais}
            />
          </Reveal>
        </PriceGrid>

        <Reveal>
          <S.Feature>
            <figure>
              <img
                src={Img5}
                alt={intl.formatMessage({ id: 'babyBoomer.imageAlt' })}
                loading="lazy"
              />
            </figure>
            <div className="body">
              <div>
                <p className="eyebrow">
                  <FormattedMessage id="babyBoomer.eyebrow" />
                </p>
                <h3>BabyBoomer</h3>
              </div>
              <PriceGroup bare items={BANHO_DE_GEL.babyBoomer} />
            </div>
          </S.Feature>
        </Reveal>
      </Inner>
    </Band>
  );
}

export default BanhoGel;
